export default {
  state: () => ({
    isLoading: false
  }),
  actions: {
    updateLoading({ commit }, payload) {
      commit('LOADING', payload)
      return Promise.resolve()
    },
    startLoading({ state, dispatch }) {
      return !state.isLoading
        ? dispatch('updateLoading', true)
        : Promise.resolve()
    },
    completeLoading({ state, dispatch }) {
      return state.isLoading
        ? dispatch('updateLoading', false)
        : Promise.resolve()
    }
  },
  mutations: {
    LOADING(state, payload) {
      state.isLoading = payload
    }
  },
  getters: {
    isLoading(state) {
      return state.isLoading
    }
  }
}
